<template>
  <div>
    <el-dialog
        :fullscreen="fullScreen"
        :title="title"
        :visible.sync="dialogVisible"
    >
      <slot name="pv"></slot>
      <span v-if="showFooter" slot="footer" class="dialog-footer">
        <el-button @click="">取 消</el-button>
        <el-button type="primary" @click="">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "previewFile",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showFooter: {
      default: false
    },
    title: {

    },
    fullScreen: {
      default: false
    },

    dialogConfig: {
      default() {
        return {
          // fullScreen: false
        }
      }
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('input',val)
    }
  },
  mounted() {
    if(this.value) {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>

</style>